import AppConstants from '../config/app.constants';

let CommonLayoutService = function ($http, $q, $translate, User) {

  let orderTypes = () => {
    return [
      {
        key: 'ADD',
        value: 'A'
      },
      {
        key: 'SWAP',
        value: 'S'
      },
      {
        key: 'ICL',
        value: 'I'
      },
      {
        key: 'CCL',
        value: 'C'
      },
      {
        key: 'RECASH',
        value: 'R'
      },
      {
        key: 'Permanent Decash',
        value: 'P'
      },
      {
        key: 'Temp Decash',
        value: 'T'
      },
      {
        key: 'TEMP DECASH & RECASH',
        value: 'T&R'
      },
      {
        key: 'Cash',
        value: 'X'
      }
    ];
  };

  let lockTypes = () => {
    return [
      {
        label: 'S&G High Security',
        value: 'LMS'
      },
      {
        label: 'Cencon - Route Mode',
        value: 'RTE'
      },
      {
        label: 'Cencon - FLM',
        value: 'FLM'
      },
      // {
      //   label: 'TDS',
      //   value: 'witz'
      // },
      {
        label: 'TDS API',
        value: 'TDS'
      },
      {
        label: 'Static',
        value: 'static'
      }
    ]
  };

  const stopProcessList = () => {
    return [
      {
        label: $translate.instant('location.atm_load'),
        value: 'L'
      },
      {
        label: $translate.instant('location.atm_cash_delivery'),
        value: 'A'
      },
      {
        label: $translate.instant('location.delivery_pickup'),
        value: 'D'
      },
      {
        label: $translate.instant('location.bin_exchange'),
        value: 'B'
      }
    ]
  }

  const OTCCompanyMapping = (OTCCompanies) => {
    const OTCCompanyNameList = [];

    if (OTCCompanies && OTCCompanies.length) {
      OTCCompanies.forEach((company) => {
        OTCCompanyNameList.push({
          label: $translate.instant(`location.${company}`),
          value: company
        })
      })
    }
    return OTCCompanyNameList;
  }

  const setOTCKeys = (OTCCompanies) => {
    const company = {}, OTCKeys = {};

    if (OTCCompanies && OTCCompanies.length) {
      OTCCompanies.forEach((c) => {
        company[c] = {
          lockSystem: [
            {
              label: 'KABA FLM',
              value: 'kabaKeyId',
            },
            {
              label: 'KABA Route',
              value: 'routeKeyId'
            },
            {
              label: 'S&G',
              value: 'SGKeyId'
            },
            {
              label: 'TDS',
              value: 'witzKeyId'
            }
          ]
        };
        OTCKeys[c] = {
          'kabaKeyId': '',
          'routeKeyId': '',
          'SGKeyId': '',
          'witzKeyId': ''
        }
      })
    }

    return { company, OTCKeys };
  }

  const denominationTypes = () => {
    return [
      {
        label: 'Penny',
        value: 'PENNY'
      },
      {
        label: 'Nickel',
        value: 'NICKEL'
      },
      {
        label: 'Dimes',
        value: 'DIMES'
      },
      {
        label: 'Quarter',
        value: 'QUARTER'
      },
      {
        label: 'Half US Dollar',
        value: 'HALF_US_DOLLAR'
      },
      {
        label: '1 US Dollar',
        value: 'ONE_US_DOLLAR'
      },
      {
        label: 'Coin Misc',
        value: 'COIN_MISC'
      },
    ]
  }

  const loadLocationTypeIcon = (locationType) => {
    if (!locationType) return;

    const icon = {
      'REGULAR': 'regular.png',
      'ATM': 'atm.png',
      'BANK': 'bank.png',
      'NO_SHIP_NO_GO': 'nsng.png',
      'INTERNAL': 'internal.png',
      'TRUCK': 'truck.png',
      'TANKER': 'tanker.png',
      'WINDOW': 'window.png',
      'ON_CALL': 'oncall.png',
      'CARRIER': 'carrier.png',
      'LOCKER': 'locker.png',
      'VAULT': 'vault.png',
      'DELIVERY': 'delivery.png'
    }
    return icon[locationType];
  }

  const getWeekDays = () => {
    return [
      { label: $translate.instant('location.sun'), value: 'Sun' },
      { label: $translate.instant('location.mon'), value: 'Mon' },
      { label: $translate.instant('location.tues'), value: 'Tue' },
      { label: $translate.instant('location.wed'), value: 'Wed' },
      { label: $translate.instant('location.thurs'), value: 'Thu' },
      { label: $translate.instant('location.fri'), value: 'Fri' },
      { label: $translate.instant('location.sat'), value: 'Sat' },
      { label: $translate.instant('location.hol'), value: 'Hol' }
    ];
  }

  const priorityList = () => {
    return [{
      label: '1st',
      value: 1
    },
    {
      label: '2nd',
      value: 2
    },
    {
      label: '3rd',
      value: 3
    },
    {
      label: '4th',
      value: 4
    },
    {
      label: '5th',
      value: 5
    }];
  }

  const multiSelectLangTranslation = () => {
    return {
      selectAll: $translate.instant('common.selectall'),
      selectNone: $translate.instant('common.selectnone'),
      reset: $translate.instant('shipmentBatch.reset'),
      search: $translate.instant('common.search'),
      nothingSelected: $translate.instant('branch.all_branches')
    }
  }

  const setUIConfig = (assets) => {
    if (!assets) return;
    setTimeout(() => {
      document.getElementById('pageTitle').innerHTML = assets.pageTitle;
      document.getElementById('company_name').innerHTML = assets.companyName;
    })
  }

  const base64toBlob = (base64Data, sliceSize = 512) => {
    const byteArrays = [];

    for (let offset = 0; offset < base64Data.length; offset += sliceSize) {
      const slice = base64Data.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new File(byteArrays, "");
  }

  const generateObjectURL = (arrayBuffer) => {
    let base64 = window.atob(Buffer.from(arrayBuffer, 'binary').toString('base64'));
    var blob = base64toBlob(base64);
    var objectURL = URL.createObjectURL(blob);
    return objectURL;
  }

  const updateFavicon = (arrayBuffer) => {
    const objectURL = generateObjectURL(arrayBuffer);
    document.querySelector("link[rel='icon']").setAttribute('href', objectURL);
  }

  const viewPassword = (stat, type, field, passWdIcon) => {
    if (!type) passWdIcon[stat][field] = !passWdIcon[stat][field];
    else passWdIcon[stat][type][field] = !passWdIcon[stat][type][field];
  }

  const ordinalSuffixOf = (number) => {
    if (!number) return;
    let j = number % 10,
      k = number % 12;
    if (j == 1 && k != 11) {
      return "Every";
    }
    if (j == 2 && k != 12) {
      return "Every " + number + "nd";
    }
    if (j == 3 && k != 13) {
      return "Every " + number + "rd";
    }
    if (number > 0) return number + "th";
    return number;
  }

  const ordinalSuffixOfStopPriority = (number) => {
    let j = number % 10,
      k = number % 100;
    if (j == 1 && k != 11) {
      return number + "st";
    }
    if (j == 2 && k != 12) {
      return number + "nd";
    }
    if (j == 3 && k != 13) {
      return number + "rd";
    }
    if (number > 0) return number + "th";
    return number;
  }

  const formatFileSize = (bytes, decimalPoint) => {
    if (bytes == 0) return '0 Bytes';
    const k = 1000,
      dm = decimalPoint || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  const locationZoneTypes = () => {
    return [
      {
        label: 'Service',
        value: 'SERVICE'
      },
      {
        label: 'Route',
        value: 'ROUTE'
      }
    ]
  }

  const billingTypeOptions = () => {
    return [
      {
        label: 'Fixed',
        value: 'fixed'
      },
      {
        label: 'Per Item',
        value: 'per_item'
      },
      {
        label: 'Item Threshold',
        value: 'item_threshold'
      },
      {
        label: 'Value Threshold',
        value: 'value_threshold'
      },
      {
        label: 'Time Threshold',
        value: 'time_threshold'
      },
      {
        label: 'Percentage Fee',
        value: 'percentage_fee'
      },
      {
        label: 'Drive Distance',
        value: 'drive_distance'
      },
      {
        label: 'Combined Time',
        value: 'combined_time'
      },
      {
        label: 'Hourly Rate',
        value: 'hourly_rate'
      },
      {
        label: 'Part Markup',
        value: 'part_markup'
      },
      {
        label: 'Service Ticket Overage Time Charge',
        value: 'service_ticket_overage_time_charge'
      }
    ];
  }

  const serviceTimeTypes = () => {
    return [
      {
        label: 'Drive Time To',
        value: 'DRIVE_TIME_TO'
      },
      {
        label: 'Drive Time From',
        value: 'DRIVE_TIME_FROM'
      }
    ]
  }

  const intervalList = () => {
    return [{
      label: 'Daily',
      value: 'DAILY'
    },
    {
      label: 'Weekly',
      value: 'WEEKLY'
    },
    {
      label: 'Monthly',
      value: 'MONTHLY'
    },
    {
      label: 'Quarterly',
      value: 'QUARTERLY'
    },
    {
      label: 'Yearly',
      value: 'YEARLY'
    }];
  }

  const bankReportTypes = () => {
    return [{
      label: 'None',
      value: 'NONE'
    },
    {
      label: 'Cash Connect',
      value: 'CASHCONNECT'
    },
    {
      label: '5TH3RD',
      value: '5TH3RD'
    },
    {
      label: 'US Bank',
      value: 'USBANK'
    }];
  }

  const configuration = () => { // Route Checkout
    return [{
      label: 'Messenger',
      value: 'messenger'
    },
    {
      label: 'Messenger/Driver',
      value: 'messenger_driver'
    },
    {
      label: 'Messenger/Driver/Guard',
      value: 'messenger_driver_guard'
    }];
  }

  const maskingString = (str) => {
    if (!str) return str;

    const start = 0;
    let end = 0;

    if (str.length == 1 || str.length == 2) end = 1;
    if (str.length == 3 || str.length == 4) end = 2;
    if (str.length === 5 || str.length === 6) end = 3;
    if (str.length > 6) end = 4;

    if (start < 0 || start >= str.length || end < 0 || end > str.length || start >= end) {
      return str;
    }

    const maskLength = end - start;
    const maskedStr = str.substring(0, start) + "*".repeat(maskLength) + str.substring(end);
    return maskedStr;
  }

  const translateItemHistoryMessage = (entryType) => {
    if (!entryType) return;
    else if (entryType === 'HOLD') return $translate.instant('shipment.hold');
    else if (entryType === 'HOLD_RELEASE') return $translate.instant('shipment.HOLD_RELEASE');
    else if (entryType === 'CHECK_IN') return $translate.instant('checkin.title');
    else if (entryType === 'CHECK_OUT') return $translate.instant('shipment.CHECKOUT');
    else if (entryType === 'ASSIGNED') return $translate.instant('shipment.assigned');
    else if (entryType === 'UNASSIGNED') return $translate.instant('shipment.UNASSIGNED');
    else if (entryType === 'LOST') return $translate.instant('shipment.lost');
    else if (entryType === 'DELETED') return $translate.instant('shipment.deleted');
    else if (entryType === 'RETURNED_AVAILABLE') return $translate.instant('item.return_to_available');
  }

  const bankWeekList = () => {
    return [{
      label: '1st',
      value: 1
    },
    {
      label: '2nd',
      value: 2
    },
    {
      label: '3rd',
      value: 3
    },
    {
      label: '4th',
      value: 4
    }];
  }

  const frequency = () => {
    return [
      {
        label: 'Weekly',
        value: 'WEEKLY'
      },
      {
        label: 'Bi-Weekly',
        value: 'BI_WEEKLY'
      },
      {
        label: 'Monthly',
        value: 'MONTHLY',
      },
      {
        label: 'Bi-Monthly',
        value: 'BI_MONTHLY',
      },
      {
        label: '2 Times Weekly',
        value: '2_TIMES_WEEKLY',
      },
      {
        label: '3 Times Weekly',
        value: '3_TIMES_WEEKLY',
      },
      {
        label: '7 Days',
        value: '7_DAYS',
      },
      {
        label: '21 Days',
        value: '21_DAYS',
      },
      {
        label: '28 Days',
        value: '28_DAYS',
      },
      {
        label: '56 Days',
        value: '56_DAYS'
      },
    ];
  }

  const dayOfWeek = () => {
    return [
      {
        label: 'Sunday',
        value: 'SUNDAY'
      },
      {
        label: 'Monday',
        value: 'MONDAY'
      },
      {
        label: 'Tuesday',
        value: 'TUESDAY'
      },
      {
        label: 'Wednesday',
        value: 'WEDNESDAY'
      },
      {
        label: 'Thursday',
        value: 'THURSDAY'
      },
      {
        label: 'Friday',
        value: 'FRIDAY'
      },
      {
        label: 'Saturday',
        value: 'SATURDAY'
      },
      {
        label: 'Holiday',
        value: 'HOLIDAY'
      }
    ];
  }

  const combinedRouteIntervals = () => {
    return [
      {
        frequency: 1,
        interval: "WEEKLY",
        label: $translate.instant('location.first_week')
      },
      {
        frequency: 2,
        interval: "WEEKLY",
        label: $translate.instant('location.second_week')
      },
      {
        frequency: 3,
        interval: "WEEKLY",
        label: $translate.instant('location.third_week')
      },
      {
        frequency: 4,
        interval: "WEEKLY",
        label: $translate.instant('location.fourth_week')
      },
      {
        frequency: 5,
        interval: "WEEKLY",
        label: $translate.instant('location.fifth_week')
      },
      {
        frequency: 6,
        interval: "WEEKLY",
        label: $translate.instant('location.sixth_week')
      },
      {
        frequency: 7,
        interval: "WEEKLY",
        label: $translate.instant('location.seventh_week')
      },
      {
        frequency: 8,
        interval: "WEEKLY",
        label: $translate.instant('location.eighth_week')
      },
      {
        frequency: 9,
        interval: "WEEKLY",
        label: $translate.instant('location.nineth_week')
      },
      {
        frequency: 1,
        interval: "MONTHOC",
        label: $translate.instant('location.first_occurrence')
      },
      {
        frequency: 2,
        interval: "MONTHOC",
        label: $translate.instant('location.second_occurrence')
      },
      {
        frequency: 3,
        interval: "MONTHOC",
        label: $translate.instant('location.third_occurrence')
      },
      {
        frequency: 4,
        interval: "MONTHOC",
        label: $translate.instant('location.fourth_occurrence')
      },
      {
        frequency: 5,
        interval: "MONTHOC",
        label: $translate.instant('location.fifth_occurrence')
      },
    ];
  }

  const dayMap = () => {
    return {
      'Sun': 0,
      'Mon': 1,
      'Tue': 2,
      'Wed': 3,
      'Thu': 4,
      'Fri': 5,
      'Sat': 6,
    }
  }

  const paymentMethod = () => {
    return [{
      label: 'Ach',
      value: 'ACH'
    },
    {
      label: 'Check',
      value: 'CHECK'
    }];
  }

  const isAllowToAccessPages = () => {
    const firstName = User.getUser().firstName;
    const lastName = User.getUser().lastName;
    const userId = User.getUser().id;
    return (
      (
        (firstName.toUpperCase() === 'COORWORKS' && lastName.toUpperCase() === 'ADMIN') || (firstName.toUpperCase() === 'ADMIN' && lastName.toUpperCase() === 'COORWORKS')
      )
      && userId === 1000
    )
  }

  const forecastingMethod = () => {
    return [
      {
        label: 'Disabled',
        value: 'DISABLED'
      },
      {
        label: 'Fixed',
        value: 'FIXED'
      },
      {
        label: 'Dynamic',
        value: 'DYNAMIC'
      }];
  }

  const atmEmptyAtCalculationMethod = () => {
    return [
      {
        label: 'Percent Change',
        value: 'PERCENT_CHANGE'
      },
      {
        label: 'Weighted Avg',
        value: 'WEIGHTED_AVG'
      },
      {
        label: 'Single',
        value: 'SINGLE'
      }];
  }

  const locationStateMapping = () => {
    return {
      AL: 'Alabama',
      AK: 'Alaska',
      AS: 'American Samoa',
      AZ: 'Arizona',
      AR: 'Arkansas',
      CA: 'California',
      CO: 'Colorado',
      CT: 'Connecticut',
      DE: 'Delaware',
      DC: 'District Of Columbia',
      FL: 'Florida',
      GA: 'Georgia',
      GU: 'Guam',
      HI: 'Hawaii',
      ID: 'Idaho',
      IL: 'Illinois',
      IN: 'Indiana',
      IA: 'Iowa',
      KS: 'Kansas',
      KY: 'Kentucky',
      LA: 'Louisiana',
      ME: 'Maine',
      MH: 'Marshall Islands',
      MD: 'Maryland',
      MA: 'Massachusetts',
      MI: 'Michigan',
      MN: 'Minnesota',
      MS: 'Mississippi',
      MO: 'Missouri',
      MT: 'Montana',
      NE: 'Nebraska',
      NV: 'Nevada',
      NH: 'New Hampshire',
      NJ: 'New Jersey',
      NM: 'New Mexico',
      NY: 'New York',
      NC: 'North Carolina',
      ND: 'North Dakota',
      MP: 'Northern Mariana Islands',
      OH: 'Ohio',
      OK: 'Oklahoma',
      OR: 'Oregon',
      PW: 'Palau',
      PA: 'Pennsylvania',
      PR: 'Puerto Rico',
      RI: 'Rhode Island',
      SC: 'South Carolina',
      SD: 'South Dakota',
      TN: 'Tennessee',
      TX: 'Texas',
      UT: 'Utah',
      VT: 'Vermont',
      VI: 'Virgin Islands',
      VA: 'Virginia',
      WA: 'Washington',
      WV: 'West Virginia',
      WI: 'Wisconsin',
      WY: 'Wyoming'
    };
  }

  const formatAmount = (val) => {
    const num = Number(val || 0);
    return num.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  const fuelTypeMapping = () => {
    return [
      { name: 'Unleaded', value: 'UNLEADED' },
      { name: 'Diesel', value: 'DIESEL' }
    ]
  }

  return {
    orderTypes,
    lockTypes,
    stopProcessList,
    OTCCompanyMapping,
    setOTCKeys,
    denominationTypes,
    loadLocationTypeIcon,
    getWeekDays,
    priorityList,
    multiSelectLangTranslation,
    setUIConfig,
    generateObjectURL,
    updateFavicon,
    viewPassword,
    ordinalSuffixOf,
    ordinalSuffixOfStopPriority,
    formatFileSize,
    locationZoneTypes,
    billingTypeOptions,
    serviceTimeTypes,
    intervalList,
    bankReportTypes,
    configuration,
    maskingString,
    translateItemHistoryMessage,
    bankWeekList,
    frequency,
    dayOfWeek,
    combinedRouteIntervals,
    dayMap,
    paymentMethod,
    isAllowToAccessPages,
    forecastingMethod,
    atmEmptyAtCalculationMethod,
    locationStateMapping,
    formatAmount,
    fuelTypeMapping
  };
};

CommonLayoutService.$inject = ['$http', '$q', '$translate', 'User']

export default CommonLayoutService;



// WEBPACK FOOTER //
// ./client/app/services/common-layout.service.js